module.exports = __webpack_public_path__ + "static/media/vibino-feature-Transparent-pic1.33c477b6.jpg";